import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";
import {
  AccordionContainer,
  PlansDetailsContainer,
} from "../../pages/Billing/styles";
import { tierMap } from "../../pages/Billing/types";
import { styles } from "./styles";
import { MinorPlanDetails } from "./MinorPlanDetails";
import { MajorPlanDetails } from "./MajorPlanDetails";
import { StudioPlanDetails } from "./StudioPlanDetails";
import { EnterpriseDetails } from "./EnterpriseDetails";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../contexts";

export const SubscriptionPlans: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const { subscriptionTier } = useContext(UserDetailsContext);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <>
      <PlansDetailsContainer>
        <Box
          style={
            tierMap[subscriptionTier] === "Minor"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5
            style={
              tierMap[subscriptionTier] === "Minor"
                ? styles.selectedPlanHeading
                : styles.planHeading
            }
          >
            OmMuse Minor Subscription
          </h5>
          <MinorPlanDetails />
        </Box>
        <Box
          style={
            tierMap[subscriptionTier] === "Major"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5
            style={
              tierMap[subscriptionTier] === "Major"
                ? styles.selectedPlanHeading
                : styles.planHeading
            }
          >
            OmMuse Major Subscription
          </h5>
          <MajorPlanDetails />
        </Box>
        <Box
          style={
            tierMap[subscriptionTier] === "Studio"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5
            style={
              tierMap[subscriptionTier] === "Studio"
                ? styles.selectedPlanHeading
                : styles.planHeading
            }
          >
            OmMuse Studio Subscription
          </h5>
          <StudioPlanDetails />
        </Box>
        <Box
          style={
            tierMap[subscriptionTier] === "Enterprise"
              ? styles.selectedSubscriptionPlan
              : { padding: "20px" }
          }
        >
          <h5 style={styles.planHeading}>OmMuse Enterprise Subscription</h5>
          <EnterpriseDetails />
        </Box>
      </PlansDetailsContainer>
      <AccordionContainer>
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          style={
            tierMap[subscriptionTier] === "Minor"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Minor</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MinorPlanDetails />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
          style={
            tierMap[subscriptionTier] === "Major"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Major</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MajorPlanDetails />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
          style={
            tierMap[subscriptionTier] === "Studio"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Studio</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <StudioPlanDetails />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
          style={
            tierMap[subscriptionTier] === "Enterprise"
              ? { backgroundColor: "#1A8899" }
              : styles.accordion
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ textAlign: "left" }}
          >
            <Box sx={styles.accordionItems}>
              <Typography sx={{ marginLeft: "20px" }}>Enterprise</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <EnterpriseDetails />
          </AccordionDetails>
        </Accordion>
      </AccordionContainer>
    </>
  );
};
